module.exports = __webpack_public_path__ + "assets/media/background.b5ba993e.mp4";